import {Auth} from "aws-amplify";
import AWS from "aws-sdk";
import awsExports from "../aws-exports";
import {Assistant} from "../components/Assistants/Assistants";

// setup global reference to AWS SDK
window.AWS = AWS;
const {apiURL} = awsExports;

export const getConfig = async function () {
  const path = 'config';
  return APIRequest({path});
}

export const postConfig = async function (attributes: any) {
  const path = 'config';
  const body = {...attributes};
  return APIRequest({path, body});
}

export const getUser = async function () {
  const path = 'user';
  return APIRequest({path});
}

/* Organizations API */

/**
 * Makes an API request to the backend API to list the organizations a user belongs to
 */
export const getOrgs = async function () {
  const path = 'orgs?include_teams=1&include_users=1';
  return APIRequest({path});
}

export const postBookmark = async function (attributes: any) {
  const path = 'bookmarks';
  const body = {
    bookmark: {
      ...attributes
    }
  };
  return APIRequest({path, body});
}

export const putBookmark = async function (attributes: any) {
  const path = `bookmarks/${attributes.id}`;
  const body = {
    bookmark: {
      ...attributes
    }
  };
  return APIRequest({path, body, method: "PUT"});
}

export const delBookmark = async function (attributes: any) {
  const path = `bookmarks/${attributes.id}`;
  return APIRequest({path, method: "DELETE"});
}

/**
 *
 * Makes an API request to the backend API to create a new organization
 * @param attributes
 */
export const postOrg = async function (attributes: any) {
  const path = 'orgs';
  const body = {
    org: {
      ...attributes
    }
  };
  return APIRequest({path, body});
}

export const putOrg = async function (attributes: any, orgId: string) {
  const path = `orgs/${orgId}`;
  const body = {
    org: {
      ...attributes
    }
  };
  return APIRequest({path, body, method: "PUT"});
}

export const postInviteOrg = async function (emails: string, scope: string, orgId: string) {
  const path = `orgs/${orgId}/invite`;
  const body = {
    org: {
      scope,
      emails
    }
  };
  return APIRequest({path, body});
}

export const getOrgUsers = async function (org: any) {
  const path = `orgs/${org.id}/users`;
  return APIRequest({path});
}

export const getOrgInvitedUsers = async function (org: any) {
  const path = `orgs/${org.id}/invited_users`;
  return APIRequest({path});
}

export const delOrgInvitedUser = async function (invitedUser: any) {
  const path = `orgs/${invitedUser.orgId}/invited_users/${invitedUser.id}`;
  return APIRequest({path, method: "DELETE"});
}

export const putOrgInvitedUser = async function (invitedUser: any, scope: string) {
  const path = `orgs/${invitedUser.orgId}/invited_users/${invitedUser.id}`;
  const body = {
    invited_user: {
      scope: scope
    }
  }
  return APIRequest({path, body, method: "PUT"});
}

export const postInviteTeam = async function (emails: string, scope: string, orgId: string, teamId: string) {
  const path = `teams/${teamId}/invite`;
  const body = {
    team: {
      scope,
      emails
    }
  };
  return APIRequest({path, body});
}

export const putOrgModifyMember = async function (orgId: string, userId: string, scope: string) {
  const path = `orgs/${orgId}/member`
  const body = {
    user: {
      userId,
      scope
    }
  };
  return APIRequest({path, body, method: 'PUT'});
}

export const delOrgRemoveMember = async function (orgId: string, userId: string) {
  const path = `orgs/${orgId}/remove_member`
  const body = {
    user: {
      userId
    }
  };
  return APIRequest({path, body, method: 'PUT'});
}

export const postTeam = async function (attributes: any, orgId: string) {
  const path = `orgs/${orgId}/teams`;
  const body = {
    team: {
      ...attributes
    }
  };
  return APIRequest({path, body});
}

export const putTeam = async function (attributes: any, orgId: string, teamId: string) {
  const path = `orgs/${orgId}/teams/${teamId}`;
  const body = {
    team: {
      ...attributes
    }
  };
  return APIRequest({path, body, method: "PUT"});
}

export const destroyTeam = async function (orgId: string, teamId: string) {
  const path = `orgs/${orgId}/teams/${teamId}`;
  return APIRequest({path, method: "DELETE"});
}

export const putTeamModifyMember = async function (orgId: string, teamId: string, userId: string, scope: string) {
  const path = `teams/${teamId}/member`
  const body = {
    orgId,
    user: {
      userId,
      scope
    }
  };
  return APIRequest({path, body, method: 'PUT'});
}

export const bookmarkTeam = async function (teamId: string) {
  const path = `teams/${teamId}/bookmark`;
  return APIRequest({path, method: "PUT"});
}

export const unBookmarkTeam = async function (teamId: string) {
  const path = `teams/${teamId}/unbookmark`;
  return APIRequest({path, method: "PUT"});
}

/**
 *
 * Makes an API request to the backend API to store the
 * AWS credentials for the provided code
 *
 * @param code 6-digit code
 */
export const postOTP = async function (code: string) {
  return Auth.currentSession().then((session) => {
    const path = `otp?code=${code}`;
    const body = {
      otp: {
        accessToken: JSON.stringify(session.getAccessToken()),
        refreshToken: JSON.stringify(session.getRefreshToken()),
        idToken: JSON.stringify(session.getIdToken()),
      }
    };
    return APIRequest({path, body});
  });
};

export const postValidateEmail = async function (email: string | number | string[] | undefined) {
  const path = 'validate/email';
  const body = {
    email
  };
  return fetch(`${apiURL}${path}`, {
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body),
    method: "POST",
  });
};


/**
 *
 * Makes an API request to the backend API to store the
 * avatar url for a user
 *
 * @param attributes
 */
export const postUser = async function (attributes: any) {
  const path = `user`;
  const body = {
    user: {
      ...attributes
    }
  };
  return APIRequest({path, body});
};

type APIRequestProps = {
  path: string;
  body?: {};
  method?: string;
};
/**
 * Makes an API call to the backend by injecting the JWT Token in the request
 * @param props
 */
const APIRequest = async function (props: APIRequestProps) {
  const {path, body, method} = props;
  return Auth.currentSession().then((session) => {
    const jwtToken = session.getIdToken().getJwtToken();
    const headers = {
      "Authorization": `Bearer ${jwtToken}`,
      "Content-Type": "application/json",
    };
    if (!body) {
      return fetch(`${apiURL}${path}`, {
        headers,
        method: method || "GET",
      });
    } else {
      return fetch(`${apiURL}${path}`, {
        headers,
        body: JSON.stringify(props.body),
        method: method || "POST",
      });
    }
  });
};

export const getSignedUrl = async function (file: any) {
  const path = `s3_uploads?type=${file.type}`;
  return APIRequest({path});
}

export const uploadFile = async function (
  signedUrl: string,
  file: any,
  onProgress: (progress: number, total: number) => void
): Promise<void> {
  await new Promise<string>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', signedUrl, true);

    xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) return
      if (xhr.status === 200) {
        resolve()
      } else {
        reject(new Error(`Request failed with status ${xhr.status}`));
      }
    }
    xhr.onprogress = e => {
      onProgress(e.loaded, e.total);
    }
    xhr.send(file);
  })
}

export const getFiles = async function () {
  const path = 'user_files';
  return APIRequest({path});
}

export const postFile = async function (file: any, url: string, folderId: string | null) {
  const path = `user_files`;
  let fileType = file.type;
  if (fileType === "" || fileType === undefined || fileType == null) {
    if (file.name.match(/\.gltf/i)) {
      fileType = "model/gltf+json"
    } else if (file.name.match(/\.obj/i)) {
      fileType = "model/obj"
    } else if (file.name.match(/\.fbx/i)) {
      fileType = "model/fbx"
    } else if (file.name.match(/\.glb/i)) {
      fileType = "model/gltf+binary"
    }
  }
  const body = {
    file: {
      name: file.name,
      size: file.size,
      mime: fileType,
      url,
      folderId
    }
  };
  return APIRequest({path, body});
}


export const putFile = async function (id: string, attributes: any) {
  const path = `user_files/${id}`;
  const body = {
    file: {
      ...attributes
    }
  };
  return APIRequest({path, body, method: 'PUT'});
}

export const delFile = async function (id: string) {
  const path = `user_files/${id}`;
  return APIRequest({path, method: "DELETE"});
}

export const postFolder = async function (attributes: any) {
  const path = 'folders';
  const body = {
    file: {
      ...attributes
    }
  };
  return APIRequest({path, body});
}

export const putFolder = async function (id: string, attributes: any) {
  const path = `folders/${id}`;
  const body = {
    file: {
      ...attributes
    }
  };
  return APIRequest({path, body, method: 'PUT'});
}

export const delFolder = async function (id: string) {
  const path = `folders/${id}`;
  return APIRequest({path, method: "DELETE"});
}

export const getPerformances = async function () {
  const path = 'performances';
  return APIRequest({path});
}

export const postPerformance = async function (attributes: any) {
  const path = 'performances';
  const body = {
    performance: {
      ...attributes
    }
  };
  return APIRequest({path, body});
}

export const putPerformance = async function (attributes: any) {
  const path = `performances/${attributes.id}`;
  const body = {
    performance: {
      ...attributes
    }
  };
  return APIRequest({path, body, method: "PUT"});
}

export const delPerformance = async function (attributes: any) {
  const path = `performances/${attributes.id}`;
  return APIRequest({path, method: "DELETE"});
}

export const getRecordingSessions = async function () {
  const path = 'recording_sessions';
  return APIRequest({path});
}

export const delRecordingSession = async function (id: string) {
  const path = `recording_sessions/${id}`;
  return APIRequest({path, method: "DELETE"});
}

export const getTeamPics = async function (team: any) {
  const path = `teams/${team.id}/team_pictures`;
  return APIRequest({path});
}

export const getTeamAssets = async function (team: any) {
  const path = `teams/${team.id}/team_assets`;
  return APIRequest({path});
}

export const getTeamUsers = async function (team: any) {
  const path = `teams/${team.id}/users`;
  return APIRequest({path});
}

export const getTeamInvitedUsers = async function (team: any) {
  const path = `teams/${team.id}/invited_users`;
  return APIRequest({path});
}

export const delTeamInvitedUser = async function (invitedUser: any) {
  const path = `teams/${invitedUser.teamId}/invited_users/${invitedUser.id}`;
  return APIRequest({path, method: "DELETE"});
}

export const putTeamInvitedUser = async function (invitedUser: any, scope: string) {
  const path = `teams/${invitedUser.teamId}/invited_users/${invitedUser.id}`;
  const body = {
    invited_user: {
      scope: scope
    }
  }
  return APIRequest({path, body, method: "PUT"});
}

export const delTeamAsset = async function (teamAsset: any) {
  const path = `teams/${teamAsset.teamId}/team_assets/${teamAsset.id}`;
  return APIRequest({path, method: "DELETE"});
}

export const delAllTeamAssets = async function (team: any) {
  const path = `teams/${team.id}/team_assets/delete_all`;
  return APIRequest({path, method: "DELETE"});
}

export const postTeamPic = async function (file: any, team: any) {
  const path = `teams/${team.id}/team_pictures`;
  const body = {
    team_picture: {
      user_files_id: file.id,
      interval: 30,
      autoplay: true,
      location: {
        x: 1.1,
        y: 2.2,
        z: 3.3,
      },
      rotation: {
        x: 30.0,
        y: 40.0,
        z: 50.0,
      },
      scale: {
        x: 1.0,
        y: 1.0,
        z: 1.0,
      }
    }
  }
  return APIRequest({path, body});
}

export const putTeamPic = async function (teamPicId: string, team: any, file: any, attributes: any) {
  const path = `teams/${team.id}/team_pictures/${teamPicId}`;
  const body = {
    team_picture: {
      ...attributes
    }
  }
  return APIRequest({path, body, method: 'PUT'});
}

export const delTeamPic = async function (team: any, teamPicId: string) {
  const path = `teams/${team.id}/team_pictures/${teamPicId}`;
  return APIRequest({path, method: "DELETE"});
}

export const getLinkedApps = async function () {
  const path = `linked_apps`;
  return APIRequest({path});
}

export const postLinkedApp = async function (attributes: any) {
  const path = 'linked_apps';
  const body = {
    linked_app: {
      ...attributes
    }
  };
  return APIRequest({path, body})
}

export const validateWalletSignature = async function (attributes: any) {
  const path = 'linked_apps/validate_wallet_signature';
  const body = {
    linked_app: {
      ...attributes
    }
  };
  return APIRequest({path, body, method: 'POST'})
}

export const delLinkedApp = async function (id: string) {
  const path = `linked_apps/${id}`;
  return APIRequest({path, method: "DELETE"});
}

export const sketchfabMe = async function () {
  const path = 'sketchfab/me'
  return APIRequest({path});
}

export const getPrompt = async function () {
  const path = 'prompts';
  return APIRequest({path});
}

export const postPrompt = async function (text: string) {
  const path = 'prompts';
  const body = {
    prompt: {
      text
    }
  }
  return APIRequest({path, body, method: 'POST'})
}

export const getAssistants = async function () {
  const path = 'assistant';
  return APIRequest({path});
}

export const getAssistant = async function (assistantId: string) {
  const path = `assistant/${assistantId}`;
  return APIRequest({path});
}

export const newAssistant = async function () {
  const path = 'assistant/new';
  return APIRequest({path});
}

export const getAssistantFiles = async function (assistantId: string) {
  const path = `assistant/${assistantId}/files`;
  return APIRequest({path});
}

export const putAssistant = async function (assistant: Assistant) {
  const path = `assistant/${assistant.id}`;
  const body = {
    assistant: {
      ...assistant
    }
  };
  return APIRequest({path, body, method: 'PUT'});
}

export const deleteAssistant = async function (assistantId: string) {
  const path = `assistant/${assistantId}`;
  return APIRequest({path, method: "DELETE"});
}

export const deleteFileFromAssistant = async function (fileId: string, assistantId: string) {
  const path = `assistant/${assistantId}/files/${fileId}`
  return APIRequest({path, method: "DELETE"});
}

export const uploadAssistantFile = async function (file: File, assistantId: string) {
  const path = `assistant/${assistantId}/upload_file`;
  const formData = new FormData();
  formData.append('file', file);

  return Auth.currentSession().then((session) => {
    const jwtToken = session.getIdToken().getJwtToken();
    const headers = {
      "Authorization": `Bearer ${jwtToken}`
    };

    return fetch(`${apiURL}${path}`, {
      headers,
      method: 'POST',
      body: formData,
    })
  });
}

export const getConversations = async function () {
  const path = 'conversations';
  return APIRequest({path});
}

export const getConversation = async function (conversationId: string) {
  const path = `conversations/${conversationId}`;
  return APIRequest({path});
}

export const putConversation = async function (conversation: any) {
  const path = `conversations/${conversation.id}`;
  const body = {
    conversation: {
      ...conversation
    }
  };
  return APIRequest({path, body, method: 'PUT'});
}

export const newConversation = async function () {
  const path = 'conversations/new';
  return APIRequest({path});
}

export const destroyConversation = async function (conversationId: string) {
  const path = `conversations/${conversationId}`;
  return APIRequest({path, method: "DELETE"});
}


export const putConversationPrompt = async function (conversationPrompt: any) {
  const path = `conversation_prompts/${conversationPrompt.id}`;
  const body = {
    conversationPrompt: {
      ...conversationPrompt
    }
  };
  return APIRequest({path, body, method: 'PUT'});
}

export const putConversationPromptPosition = async function (conversationPrompt: any, positionAfter: string|null) {
  return putConversationPrompt({
    ...conversationPrompt,
    position: { after: positionAfter },
  })
}

export const newConversationPrompt = async function (conversationId: string) {
  const path = `conversation_prompts/new?conversationId=${conversationId}`;
  return APIRequest({path});
}

export const deleteConversationPrompt = async function (promptId: string) {
  const path = `conversation_prompts/${promptId}`;
  return APIRequest({path, method: "DELETE"});
}
